module.exports = __webpack_public_path__ + "static/media/UnitedSansReg-Heavy.9c996585.woff";